import React from 'react';
import { ISVGProps } from 'components/svg/legacyIcons_DO_NOT_USE/types';
import DollarIcon from './Dollar';

export default (props: ISVGProps) => <DollarIcon {...props} />;
